package com.milta.core.localization.translations.sq

import com.milta.core.localization.LoadingAddressStrings

internal val LoadingAddress = LoadingAddressStrings(
    title = "Adresa e ngarkimit",
    emptyMessage = "Për të optimizuar turin, tregoni ku i ngarkojnë mallrat shoferët tuaj. Adresa do të ruhet për turet tuaja të ardhshme.",
    selectPlaceholder = "Zgjidhni një adresë ngarkimi",
    sheetSubtitle = "Aty ku shoferët tuaj marrin mallrat.",
    startPointBadge = "Pika e nisjes",
    newAddressAction = "Adresë e re",
    mobileSearchPlaceholder = "Rruga, numri, komuna",
    webSearchPlaceholder = "Kërkoni një adresë…",
    deleteDialogTitle = "Ta fshini këtë adresë?",
    deleteDialogMessage = "„%s” nuk do të propozohet më. Turet e krijuara tashmë nuk ndryshojnë.",
    webSubmitBlockedHint = "Zgjidhni një adresë ngarkimi për të optimizuar.",
    errorRequired = "Zgjidhni një adresë ngarkimi.",
)
